const BASE = process.env.REACT_APP_APIURL || 'http://localhost:4000/';
const api = (path) => `${BASE.replace(/\/$/, '')}/${path}`;

export class PreguntaApi {
  async getPreguntasByIdTest(id_test) {
    const res = await fetch(api(`pregunta/${id_test}`));
    if (!res.ok) throw new Error(`getPreguntasByIdTest: ${res.status}`);
    return res.json();
  }

  async insertPregunta(data) {
    const res = await fetch(api('pregunta'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!res.ok) throw new Error(`insertPregunta: ${res.status}`);
    return res.json();
  }

  async updatePregunta(id, data) {
    const res = await fetch(api(`pregunta/${id}`), {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!res.ok) {
      const txt = await res.text().catch(() => '');
      throw new Error(`updatePregunta ${res.status}: ${txt.slice(0,120)}`);
    }
    return res.json();
  }

  async deletePregunta(id) {
    const res = await fetch(api(`pregunta/${id}`), { method: 'DELETE' });
    if (!res.ok) throw new Error(`deletePregunta: ${res.status}`);
    return { success: true };
  }
}
